import { lazy } from "react";

export const ReadingDetailsAsync = lazy(() => import("./ReadingDetails"));
